<template>
    <div class="updater">
        <base-box>
            <p class="title">Atualização disponível</p>
            <p class="icon"><i class="fal fa-arrow-circle-down"></i></p>

			<p class="message">Mantenha seu sistema atualizado para garantir o funcionamento perfeito de todos os nossos recursos.</p>

			<base-message v-if="true" class="w-100 mt_20 text-left">
                Seu sistema precisará ser reinicializado.
            </base-message>

            <div class="d-flex w-100 mt_30">
                <base-button design="four" class="mr_7 update-later" @click="updateNowOrLater('onUpdateLater')"><i class="fal fa-clock fs-14" title="Adiar atualização"></i></base-button>
                <base-button text="Atualizar agora" @click="updateNowOrLater('onUpdateNow')" class="w-100 ml_7 big flex"/>
            </div>
        </base-box>
    </div>
</template>

<script>
import BaseBox from '@/components/Box';
import BaseButton from '@/components/Button';
import BaseLabel from '@/components/Label';
import BaseQuestion from '@/components/Question';
import BaseMessage from '@/components/Message';

import AppBridge from "@/plugins/app";
import DesktopBridge from "@/plugins/desktop";

import store from '@/store';

export default {
	props: {
		updateType: { type: String }
	},
	methods: {
		async updateNowOrLater(eventType) {
			if (this.updateType == 'clientUpdate' && !DesktopBridge.isDesktop()) {
                this.$forceUpdate();
                this.$router.go();
			} else {
				if (AppBridge.isApp()) {
					AppBridge.emit(eventType);
				} else if (DesktopBridge.isDesktop()) {
					DesktopBridge.emit(eventType, this.updateType);
				} else if ( eventType != 'onUpdateLater' && !AppBridge.isApp() && !DesktopBridge.isDesktop()) {
                    this.$router.go();
                }
			}

			if (eventType == 'onUpdateLater') {
				store.commit('store/setUpdateLater', true);
			}

			store.commit('store/setHasUpdate', false);
		},
	},
    components: {
        BaseBox,
        BaseButton,
        BaseLabel,
        BaseQuestion,
        BaseMessage,
    }
}
</script>

<style scoped>
    .updater {
        position: fixed;
        width: 100vw;
        height: 100vh;
        z-index: 10000;
        background: rgba(0,0,0,0.5);
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .updater > *:first-child {
        width: 400px;
        max-width: 92%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .updater .title {
        font-size: 1.8em;
        line-height: 22px;
        font-weight: 900;
        color: var(--default);
        margin-bottom: 20px;
    }

    .update-later {
        flex: 0 52px;
        color: var(--icon-inactive);
    }

    .updater .icon {
        font-size: 41px;
        color: var(--default);
        margin-bottom: 15px;
    }

    .updater .message {
        color: #A6A6A6;
        font-weight: 300;
        font-size: 1.2em;
        line-height: 16px;
        padding: 0 20px;
    }
</style>